import { assets } from '@/assets';
import { cssVars } from '@/lib/cssVars';
import { cx } from '@/lib/cx';
import styles from './MicButton.module.css';

export type MicState = 'idle' | 'listening' | 'busy';

interface MicButtonProps {
  state: MicState;
  label: string;
  /** Diameter of the visible button in design units. */
  size: number;
  disabled?: boolean;
  /** Whether the microphone is switched on (defaults to `state === 'listening'`). */
  pressed?: boolean;
  onPress: () => void;
}

/** The big record button: idle art, and listening art with sound waves and a pulse. */
export function MicButton({ state, label, size, disabled, pressed, onPress }: MicButtonProps) {
  const { micIdle, micListening } = assets.ui.buttons;
  return (
    <button
      type="button"
      className={cx(styles.mic, styles[state])}
      style={cssVars({ '--size': size })}
      aria-label={label}
      aria-pressed={pressed ?? state === 'listening'}
      disabled={disabled}
      onClick={onPress}
    >
      <span className={styles.ripple} aria-hidden />
      <img className={styles.idleArt} src={micIdle.url} alt="" draggable={false} />
      <img className={styles.activeArt} src={micListening.url} alt="" draggable={false} />
    </button>
  );
}
